/**
 * It's going to download a text file with any extension, we just need to pass the filename and the text
 * @param filename - The filename of the file to download
 * @param text Whatever it's going to contain the file
 */
export function downloadGeneratedFile(filename: string, text: string) {
  var element = document.createElement('a')
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  )
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}
